<template>
    <div v-if="Object.keys(orderData).length != 0">
        <div v-if="loading" class="loading-container">
            <atom-spinner
                :animation-duration="1000"
                :size="60"
                color="#ff1d5e"
            />
        </div>
        <div v-if="!loading">
            <div>
                <b-row class="order-details-header">
                    <b-col cols="12" sm="8">
                        <h3 class="text-primary page-title">Order Details</h3>
                    </b-col>
                    <b-col cols="12" sm="4" class="text-right text-sm-right mb-2 mb-sm-0">
                        <b-button
                            class="back-btn"
                            @click="
                                $router.push({
                                    name: 'Customer-Management-Listing',
                                    params: {
                                        id: $route.params.customerId,
                                    },
                                })
                            "
                            variant="primary"
                            >Back</b-button
                        >
                    </b-col>
                </b-row>
                <b-card class="mt-2">
                    <div
                        v-if="orderData.orderStatus !== 'Cancelled'"
                        class="steps d-flex flex-wrap flex-sm-nowrap justify-content-between"
                    >
                        <div
                            :class="`step ${
                                orderStatus(orderData.orderStatus) >= 0
                                    ? 'completed'
                                    : ''
                            }`"
                        >
                            <div class="step-icon-wrap">
                                <div class="step-icon">
                                    <i
                                        class="fa fa-check"
                                        aria-hidden="true"
                                    ></i>
                                </div>
                            </div>
                            <h4 class="step-title">Order</h4>
                        </div>
                        <div
                            :class="`step ${
                                orderStatus(orderData.orderStatus) >= 1
                                    ? 'completed'
                                    : ''
                            }`"
                        >
                            <div class="step-icon-wrap">
                                <div class="step-icon">
                                    <i class="fa fa-cog" aria-hidden="true"></i>
                                </div>
                            </div>
                            <h4 class="step-title">Under Process</h4>
                        </div>
                        <div
                            :class="`step ${
                                orderStatus(orderData.orderStatus) >= 2
                                    ? 'completed'
                                    : ''
                            }`"
                        >
                            <div class="step-icon-wrap">
                                <div class="step-icon">
                                    <i
                                        class="fa fa-truck"
                                        aria-hidden="true"
                                    ></i>
                                </div>
                            </div>
                            <h4 class="step-title">Shipped</h4>
                        </div>
                        <div
                            :class="`step ${
                                orderStatus(orderData.orderStatus) >= 3
                                    ? 'completed'
                                    : ''
                            }`"
                        >
                            <div class="step-icon-wrap">
                                <div class="step-icon">
                                    <i
                                        class="fa fa-home"
                                        aria-hidden="true"
                                    ></i>
                                </div>
                            </div>
                            <h4 class="step-title">Delivered</h4>
                        </div>
                    </div>
                    <div
                        v-else
                        class="steps d-flex flex-wrap flex-sm-nowrap justify-content-between"
                    >
                        <div
                            :class="`step ${
                                orderStatus(orderData.orderStatus) >= 0
                                    ? 'completed'
                                    : ''
                            }`"
                        >
                            <div class="step-icon-wrap">
                                <div class="step-icon">
                                    <i
                                        class="fa fa-check"
                                        aria-hidden="true"
                                    ></i>
                                </div>
                            </div>
                            <h4 class="step-title">Order</h4>
                        </div>
                        <div
                            :class="`step ${
                                orderStatus(orderData.orderStatus) >= 1
                                    ? 'Cancelled'
                                    : ''
                            }`"
                        >
                            <div class="step-icon-wrap">
                                <div class="step-icon cancelbg">
                                    <i
                                        class="fa fa-times text-danger"
                                        aria-hidden="true"
                                    ></i>
                                </div>
                            </div>
                            <h4 class="step-title">Cancelled</h4>
                        </div>
                    </div>
                </b-card>

                <b-card class="order-info-card">
                    <b-row class="order-info-row">
                        <b-col cols="12" sm="12" md="4" class="mb-3 mb-md-0">
                            <h5>
                                Order# :
                                <span class="span-text">{{
                                    orderData.orderId
                                }}</span>
                            </h5>
                            <h5>
                                Order Type :
                                <span class="span-text">{{
                                    orderData.type
                                }}</span>
                            </h5>
                            <h5>
                                Order Date :
                                <span class="span-text">{{
                                    orderData.createdAt | formatedate
                                }}</span>
                            </h5>
                        </b-col>
                        <b-col cols="12" sm="6" md="3" class="mb-3 mb-md-0">
                            <h5 class="h5-text">
                                Seller Name :
                                <span class="span-text">
                                    {{
                                        providerDetails &&
                                        providerDetails.office
                                            ? providerDetails.office.officeName
                                            : ""
                                    }}</span
                                >
                            </h5>
                            <h5 class="h5-text">
                                Address :
                                <span class="span-text">
                                    {{
                                        providerDetails &&
                                        providerDetails.office
                                            ? providerDetails.office.address
                                                  .city
                                            : ""
                                    }},
                                    {{
                                        providerDetails &&
                                        providerDetails.office
                                            ? providerDetails.office.address
                                                  .state
                                            : ""
                                    }},
                                    <br class="mt-1" />
                                    {{
                                        providerDetails &&
                                        providerDetails.office
                                            ? providerDetails.office.address
                                                  .country
                                            : ""
                                    }},
                                    {{
                                        providerDetails &&
                                        providerDetails.office
                                            ? providerDetails.office.address.zip
                                            : ""
                                    }}
                                </span>
                            </h5>
                            <h5 class="h5-text">
                                Phone :
                                <span
                                    v-if="
                                        providerDetails &&
                                        providerDetails.office &&
                                        providerDetails.office.phone
                                    "
                                    class="span-text"
                                >
                                    <span
                                        v-for="i in providerDetails.office
                                            .phone"
                                        :key="i._id"
                                    >
                                        {{ i.number }},
                                    </span>
                                </span>
                                <span v-else class="span-text">N/A</span>
                            </h5>
                        </b-col>
                        <b-col cols="12" sm="6" md="3" class="mb-3 mb-md-0">
                            <h5>
                                Pickup address :
                                <span class="span-text">
                                    {{
                                        pickUpAddress && pickUpAddress.address
                                            ? pickUpAddress.address.City
                                            : ""
                                    }}
                                    {{
                                        pickUpAddress && pickUpAddress.address
                                            ? pickUpAddress.address.State
                                            : ""
                                    }}
                                    {{
                                        pickUpAddress && pickUpAddress.address
                                            ? pickUpAddress.address.Country
                                            : ""
                                    }}</span
                                >
                            </h5>
                            <h5>
                                Phone :
                                <span class="span-text">{{
                                    pickUpAddress ? pickUpAddress.phone : ""
                                }}</span>
                            </h5>
                        </b-col>
                        <b-col cols="12" sm="12" md="2" class="mb-3 mb-md-0">
                            <h5>
                                Total Amount :
                                <span class="total-amount-text">
                                    ₹
                                    {{
                                        orderData ? orderData.orderAmount : ""
                                    }}</span
                                >
                            </h5>
                            <h5>
                                Status :
                                <span class="span-text status-green">
                                    {{
                                        orderData ? orderData.orderStatus : ""
                                    }}</span
                                >
                            </h5>
                        </b-col>
                    </b-row>
                </b-card>

                <div class="mt-2">
                    <b-row class="order-details-content-row">
                        <b-col cols="12" sm="12" md="6" v-if="isAddressAdded" class="mb-3 mb-md-0">
                            <h4 class="section-title">Customer & Delivery Details</h4>
                            <div class="delivery-details-card border">
                                <div class="p-2">
                                    <b-button
                                        class="edit-btn-float"
                                        variant="primary"
                                        ><i class="fas fa-edit"></i
                                    ></b-button>
                                    <h5 class="h5-text">
                                        Customer Name :{{
                                            orderData &&
                                            orderData.deliveryAddress &&
                                            orderData.deliveryAddress.address
                                                ? orderData.deliveryAddress
                                                      .address.fullName
                                                : ""
                                        }}
                                    </h5>
                                    <h5 class="mt-2">
                                        Delivery address :
                                        {{
                                            orderData &&
                                            orderData.deliveryAddress &&
                                            orderData.deliveryAddress.address
                                                ? orderData.deliveryAddress
                                                      .address.houseNumber
                                                : ""
                                        }}
                                        {{
                                            orderData &&
                                            orderData.deliveryAddress &&
                                            orderData.deliveryAddress.address
                                                ? orderData.deliveryAddress
                                                      .address.street1
                                                : ""
                                        }}
                                        {{
                                            orderData &&
                                            orderData.deliveryAddress &&
                                            orderData.deliveryAddress.address
                                                ? orderData.deliveryAddress
                                                      .address.city
                                                : ""
                                        }},
                                        {{
                                            orderData &&
                                            orderData.deliveryAddress &&
                                            orderData.deliveryAddress.address
                                                ? orderData.deliveryAddress
                                                      .address.state
                                                : ""
                                        }},
                                        <br />
                                        {{
                                            orderData &&
                                            orderData.deliveryAddress &&
                                            orderData.deliveryAddress.address
                                                ? orderData.deliveryAddress
                                                      .address.country
                                                : ""
                                        }},
                                        {{
                                            orderData &&
                                            orderData.deliveryAddress &&
                                            orderData.deliveryAddress.address
                                                ? orderData.deliveryAddress
                                                      .address.zip
                                                : ""
                                        }}
                                    </h5>
                                    <div
                                        v-for="(phn, k) in orderData
                                            .deliveryAddress.address.contacts"
                                        :key="k"
                                    >
                                        <h5
                                            v-if="
                                                phn.contactType ===
                                                'PRIMARY_PHONE'
                                            "
                                        >
                                            Customer Phone :
                                            {{ phn ? phn.value : "NA" }}
                                        </h5>
                                    </div>
                                </div>
                            </div>
                        </b-col>
                        <b-col cols="12" sm="12" md="3" class="mb-3 mb-md-0">
                            <h4 class="section-title">Order Details</h4>
                            <div class="order-details-card border">
                                <div class="p-2">
                                    <h5>
                                        Order Amount : ₹
                                        {{
                                            orderData
                                                ? orderData.orderAmount
                                                : ""
                                        }}
                                    </h5>
                                    <h5>
                                        Delivery charge: ₹
                                        {{
                                            orderData
                                                ? orderData.deliveryCharges
                                                : ""
                                        }}
                                    </h5>
                                    <h5>
                                        Payment Mode :
                                        {{
                                            orderData
                                                ? orderData.paymentType
                                                : ""
                                        }}
                                    </h5>
                                    <h5>
                                        <span class="payment-ref-text"
                                            >Payment trans Ref:</span
                                        >
                                        <span class="text-black"> #123456</span>
                                    </h5>
                                    <h5 class="coupon-text">
                                        Coupon Applied : Summer50
                                    </h5>
                                </div>
                            </div>
                        </b-col>

                       <b-col cols="12" sm="12" md="3">
    <h5 class="section-title">Order Status:</h5>

    <div class="order-status-card border">
        <div class="p-2">

            
            <eb-select
                placeholder="Select Status type"
                label="text"
                type="text"
                :options="statusList"
                @input="updateOrderStatus"
            >
            </eb-select>

            
            <b-col
                v-if="
                    selectedStatus &&
                    (selectedStatus.value === 'Returned' ||
                     selectedStatus.value === 'Refund')
                "
            >
                <c-input
                    class="mt-n2"
                    inputType="text"
                    v-model="referenceValue"
                    :labelText="
                        selectedStatus.value === 'Returned'
                            ? 'Reference Number'
                            : 'Refund Amount'
                    "
                />
            </b-col>

           
            <b-row class="mt-2">
                <b-col cols="12" sm="6" md="6" class="mb-2 mb-sm-0">
                    <h5>Update ETA :</h5>
                    <b-input type="date" v-model="etaTime"></b-input>
                </b-col>

                <b-col cols="12" sm="6" md="6">
                    <h5>Update Pick up time :</h5>
                    <b-input type="date" v-model="pickUpTime"></b-input>
                </b-col>
            </b-row>

           

<div class="text-center mt-3">
  <b-button
    class="update-status-btn"
    variant="primary"
    @click="updateOrderStatusButton"
  >
    Update Status
  </b-button>
</div>



        </div>
    </div>
</b-col>

                    </b-row>
                </div>

                <b-table
                    class="mt-3"
                    striped
                    hover
                    :fields="title"
                    thead-class="header"
                    :bordered="true"
                    :items="orderData.items"
                    @filtered="onFilter"
                    :current-page="1"
                    :per-page="10"
                >
                    <template slot="cell(imageLink)" slot-scope="data">
                        <div>
                            <img
                                class="order-item-image"
                                :src="data.item.imageLink"
                                alt="Not Available"
                            />
                        </div>
                    </template>
                </b-table>
                <b-row class="mx-2"
                    ><b-col>
                        <b-pagination
                            v-model="currentPage"
                            :per-page="perPage"
                            :total-rows="filterCount"
                            aria-controls="my-table"
                            prev-text="Prev"
                            next-text="Next"
                            hide-goto-end-buttons
                        ></b-pagination
                    ></b-col>
                                <b-col cols="12" sm="12" md="5" class="mt-3 mt-md-0">
                        <div class="mx-2 p-3 order-summary-card">
                            <b-row>
                                <b-col cols="12" md="4" class="d-none d-md-block"> </b-col>
                                <b-col cols="12" md="8">
                                    <b-row class="m-0">
                                        <b-col cols="6" sm="6" md="6">
                                            <h4>Sub-Total</h4>
                                            <hr />
                                            <h4>Shipping</h4>
                                            <hr />
                                            <h5
                                                v-for="(
                                                    gst, count
                                                ) in gstCalculation"
                                                :key="count"
                                            >
                                                {{ gst.type }} @
                                                {{ gst.percent }} %
                                            </h5>
                                        </b-col>
                                        <b-col cols="6" sm="6" md="6">
                                            <h5>
                                                ₹
                                                {{
                                                    orderData.orderAmount -
                                                    orderData.deliveryCharges -
                                                    getTotalTax.toFixed(2)
                                                }}
                                            </h5>
                                            <hr />
                                            <h5>
                                                ₹
                                                {{ orderData.deliveryCharges }}
                                            </h5>
                                            <hr />
                                            <h5
                                                v-for="(
                                                    gst, count
                                                ) in gstCalculation"
                                                :key="count"
                                            >
                                                ₹ {{ gst.taxAmount }}
                                            </h5>
                                        </b-col>
                                    </b-row>
                                </b-col>
                            </b-row>
                            <hr class="hr-dotted mt-n3" />
                            <b-row class="mt-n3">
                                <b-col cols="12" sm="8" md="8">
                                    <h3>Total</h3>
                                </b-col>
                                <b-col cols="12" sm="4" md="4">
                                    <h3>₹ {{ orderData.orderAmount }}</h3>
                                </b-col>
                            </b-row>
                            <hr class="hr-dotted mt-n2" />
                        </div>
                    </b-col>
                </b-row>
            </div>
        </div>
    </div>
</template>

<script>
import moment from "moment";
import ebSelect from "@/components/FormElements/Select.vue";
import { AtomSpinner } from "epic-spinners";
import cInput from "@/components/Common/CustomInput";
export default {
    components: {
        ebSelect,
        cInput,
        AtomSpinner,
    },
    data() {
        return {
            orderObject: {},
            loading: false,
            etaTime: "",
            pickUpTime: "",
            title: [
                { key: "imageLink", label: "Item Image" },
                { key: "name", label: "Item Name" },
                { key: "qty", label: "Item Quantity" },
                {
                    key: "unitPrice",
                    label: "Unit Price",
                },
                {
                    key: "discount",
                    label: "Discount",
                },
                {
                    key: "price",
                    label: "Total Price",
                },
            ],
            statusList: [
                {
                    text: "Dispatched",
                    value: "Dispatched",
                },
                {
                    text: "Delivered",
                    value: "Delivered",
                },
                {
                    text: "Cancelled",
                    value: "Cancelled",
                },
                {
                    text: "Returned",
                    value: "Returned",
                },
                {
                    text: "Refund",
                    value: "Refund",
                },
            ],
            perPage: 7,
            currentPage: 1,
            filterCount: 0,
            selectedStatus: "",
            referenceValue: "",
        };
    },
    filters: {
        formatedate: function (value) {
            if (value) {
                return moment(String(value)).format("DD-MMM-YYYY hh:mm A");
            }
        },
    },
    computed: {
        orderData() {
            if (this.orderObject) {
                return this.orderObject;
            } else {
                return {};
            }
        },
        getTotalTax() {
            let totalTax = 0;
            try {
                this.gstCalculation.forEach((obj) => {
                    totalTax = totalTax + obj.taxAmount;
                });
                return totalTax;
            } catch {
                return totalTax;
            }
        },
        gstCalculation() {
            if (this.isItemAdded) {
                let taxCalculate = [];

                this.orderData.items.forEach((obj) => {
                    taxCalculate.push(...obj.taxes);
                });
                return taxCalculate;
            } else {
                return {};
            }
        },
        isItemAdded() {
            if (this.orderData.items && this.orderData.items !== undefined) {
                return true;
            } else {
                return false;
            }
        },
        providerDetails() {
            let data = this.$store.getters["partner/GetPartnerDetailsById"];
            try {
                if (data._id) {
                    return data;
                } else {
                    return {};
                }
            } catch {
                return {};
            }
        },
        pickUpAddress() {
            let data = this.$store.getters["item/GetItemDetailsById"];
            let returnObj = {
                address: "",
                phone: "",
                name: "",
            };
            if (data[0] && data[0].Address) {
                returnObj.address = data[0] ? data[0].Address : "";
            }
            if (data[0] && data[0].sellerContact) {
                returnObj.phone = data[0] ? data[0].sellerContact : "";
            }
            if (data[0] && data[0].providerName) {
                returnObj.name = data[0] ? data[0].providerName : "";
            }

            return returnObj;
        },
        isOfficeAdded() {
            if (
                this.providerDetails.office &&
                this.providerDetails.office.address !== undefined
            ) {
                return true;
            } else {
                return false;
            }
        },
        orderList() {
            return this.$store.getters["customerManagement/GetOrderList"];
        },
        isAddressAdded() {
            if (
                this.orderData &&
                this.orderData.deliveryAddress &&
                this.orderData.deliveryAddress.address !== undefined
            ) {
                return true;
            } else {
                return false;
            }
        },
    },
    methods: {
        onFilter(list) {
            this.filterCount = list.length;
            this.currentPage = 1;
        },
        updateOrderStatus(e) {
            this.selectedStatus = e;
        },
        UpdatePickupTime() {
            const dataObj = {
                actionCode: 2,
                conditions: {
                    orderId: this.orderData.orderId,
                    isRunning: true,
                    fullfillmentId: this.orderData.fullfillmentId,
                },
                set: {
                    etaInMins: this.etaTime,
                    pickUpTime: this.pickUpTime,
                },
            };

            this.$store
                .dispatch("order/updatePickupTime", dataObj)
                .then((res) => {
                    this.$swal({
                        title: "Updated!",
                        text: "ETA & Pickup Time is Updated Successfully!",
                        type: "success",
                    });
                    this.ETATime = "";
                    this.pickUpTime = "";
                });
        },
        updateOrderStatusButton() {
            let dataObj = {
                actionCode: 20,
                conditions: {
                    orderId: this.orderData.orderId,
                    isRunning: true,
                    fullfillmentId: this.orderData.fullfillmentId,
                },
                set: {
                    orderStatus: this.selectedStatus.value,
                    reportStatus: this.selectedStatus.value,
                },
                push: {
                    reportStatusHistory: {
                        label: this.selectedStatus.value,
                        message: `Your order is ${this.selectedStatus.value}`,
                    },
                },
            };
            if (this.selectedStatus.value === "Returned") {
                dataObj.set["orderReturn"] = {
                    shippingRef: this.referenceValue,
                    shippingService: "",
                };
            } else if (this.selectedStatus.value === "Refund") {
                dataObj.set["orderReturn"] = {
                    refundAmt: this.referenceValue,
                };
            }
            this.$store
                .dispatch("order/updatePickupTime", dataObj)
                .then((res) => {
                    this.$swal({
                        title: "Updated!",
                        text: "Order status is Updated Successfully!",
                        type: "success",
                    });
                });
        },

        orderStatus(e) {
            switch (e) {
                case "Created":
                    return 0;
                case "Processing":
                    return 1;
                case "Dispatched":
                    return 2;
                case "Delivered":
                    return 3;
                default:
                    return -1;
            }
        },
        async fetchOrderData() {
            if (this.orderList.length > 0) {
                this.orderObject = await this.orderList.find(
                    (obj) => obj._id === this.$route.params.id,
                );
            }
            try {
                if (this.orderData.provider) {
                    await this.$store.dispatch(
                        "partner/fetchPartnerDetailsById",
                        this.orderData.provider._id,
                    );
                }
            } catch {}
            try {
                if (
                    Array.isArray(this.orderData.items) &&
                    this.orderData.items.length > 0
                ) {
                    await this.$store.dispatch(
                        "item/fetchItemDetailsById",
                        this.orderData.items[0].productId,
                    );
                }
            } catch {}
        },
    },
    created() {
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
    },
    async mounted() {
        this.loading = true;
        await this.fetchOrderData();
        this.loading = false;
    },
};
</script>
<style scoped>
.loading-container {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 300px;
}

.order-details-header {
    align-items: center;
    margin-bottom: 1rem;
}

.page-title {
    margin-bottom: 0;
}

.back-btn {
    float: right;
}

.steps .step {
    display: block;
    width: 100%;
    margin-bottom: 25px;
    text-align: center;
    z-index: 1;
}

.steps .step .step-icon-wrap {
    display: block;
    position: relative;
    width: 100%;
    height: 60px;
    text-align: center;
}

.steps .step .step-icon-wrap::before,
.steps .step .step-icon-wrap::after {
    display: block;
    position: absolute;
    top: 50%;
    width: 50%;
    height: 3px;
    margin-top: -1px;
    background-color: #e1e7ec;
    content: "";
    z-index: 1;
}

.steps .step .step-icon-wrap::before {
    left: 0;
}

.steps .step .step-icon-wrap::after {
    right: 0;
}

.steps .step .step-icon {
    display: inline-block;
    position: relative;
    width: 65px;
    height: 60px;
    border: 1px solid #e1e7ec;
    border-radius: 50%;
    background-color: #f5f5f5;
    color: #374250;
    font-size: 28px;
    line-height: 61px;
    z-index: 5;
}

.steps .step .step-title {
    margin-top: 16px;
    margin-bottom: 0;
    color: #606975;
    font-size: 14px;
    font-weight: 500;
}

.steps .step:first-child .step-icon-wrap::before {
    display: none;
}

.steps .step:last-child .step-icon-wrap::after {
    display: none;
}

.steps .step.completed .step-icon-wrap::before,
.steps .step.completed .step-icon-wrap::after {
    background-color: #04c800;
}

.steps .step.completed .step-icon {
    border-color: #04c800;
    background-color: #04c800;
    color: #fff;
}

.update-status-btn {
    display: inline-block !important;
    width: auto !important;
    padding: 4px 12px !important;
    font-size: 15px !important;
    white-space: nowrap !important;
}

.order-info-card {
    border-radius: 6px;
    background-color: #e5e5e5;
}

.order-info-row {
    align-items: flex-start;
}

.total-amount-text {
    font-size: 15px;
}

.status-green {
    color: #42b039;
}

.section-title {
    margin-bottom: 0.75rem;
}

.order-details-content-row {
    align-items: flex-start;
}

.delivery-details-card {
    background-color: #fcfcfc;
    min-height: 150px;
    height: auto;
}

.edit-btn-float {
    float: right;
    border-radius: 40px;
    height: 37px;
}

.order-details-card {
    background-color: #fcfcfc;
    min-height: 150px;
    height: auto;
}

.payment-ref-text {
    color: red;
}

.coupon-text {
    color: red;
}

.order-status-card {
    background-color: #fcfcfc;
    min-height: 260px;
    height: auto;
    margin-top: 15px;
}

.order-item-image {
    height: 50px;
    width: auto;
    max-width: 100%;
    object-fit: contain;
}

.hr-dotted {
    border-top: 1px dotted #d6d6d6;
}

.order-summary-card {
    background-color: #fff;
}

@media (max-width: 767.98px) {
    .back-btn {
        float: none;
        width: 100%;
    }

    .order-info-card {
        border-radius: 0;
    }

    .delivery-details-card,
    .order-details-card,
    .order-status-card {
        min-height: auto;
    }

    .edit-btn-float {
        float: none;
        width: 100%;
        margin-bottom: 0.5rem;
    }

    .steps .step {
        margin-bottom: 15px;
    }

    .steps .step .step-icon {
        width: 50px;
        height: 50px;
        font-size: 20px;
        line-height: 50px;
    }

    .steps .step .step-title {
        font-size: 12px;
    }
}

@media (max-width: 575.98px) {
    .page-title {
        font-size: 1.25rem;
    }

    .section-title {
        font-size: 1rem;
    }

    .order-summary-card {
        padding: 1rem !important;
    }
}
</style>
